import { getShortenCountryName } from './use-origin-country';

/**
 * The name Google should print beside our results instead of the bare domain.
 *
 * Every page on a domain has to agree on it. A domain that calls itself
 * "Reebelo United Kingdom" on its homepage and plain "Reebelo" on the product
 * and collection pages — which is most of what gets indexed — leaves Google
 * with no name it can trust, and it falls back to showing "reebelo.co.uk".
 */
export const SITE_NAME = `Reebelo ${getShortenCountryName()}`;
